<p-toast> </p-toast>

<section class="toggle-form" [ngClass]="{ active: isCurriculumSliderOpen }">
  <div class="formwrap">
    <div class="Header">
   <h2>
    <b>Add Training Item</b>
  </h2>
    <div>
      <p-button
      appPreventDoubleClick
        styleClass="p-button-text"
        id="curriculumSliderCloseButton"
        type="button"
        label="Close"
        (debounceClick)="closeSlider()"
      ></p-button>
    </div>
    </div>
    <div class="general-container content">
      <p-tabView  [(activeIndex)]="activeTab" (onChange)="onTabChange($event)">
        <p-tabPanel
          header="Training Item Group"
        >
        <div class="content">
          <app-curriculum-training-item-group-details [selectedScope]="selectedScope">

          </app-curriculum-training-item-group-details>
        </div>
        </p-tabPanel>
        <p-tabPanel header="Document" [rightIcon]="errorIconClassForDocumentTab">
            <div class="content">
                <app-curriculum-document-details 
                [selectedScope]="selectedScope"
                [eqmsScopeTreeNodes]="eqmsScopeTreeNodes"
                (activateTabIndex)="openCurrentTab($event)">
              </app-curriculum-document-details>
            </div>
        </p-tabPanel>
        <p-tabPanel header="Course" [rightIcon]="errorIconClassForCourseTab">
          <app-curriculum-course-details 
          [selectedScope]="selectedScope" 
          [eqmsScopeTreeNodes]="eqmsScopeTreeNodes"
          (activateTabIndex)="openCurrentTab($event)">
        </app-curriculum-course-details>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</section>